import { UIActionReactionText } from "chat/enums";

interface GetReactionsTextAnalyticsParameter {
  isFamilyChat: boolean;
  isGroupChat: boolean;
  isSystemChat: boolean;
}

export const getReactionsTextAnalyticsParameter = ({
  isFamilyChat,
  isSystemChat,
  isGroupChat,
}: GetReactionsTextAnalyticsParameter): UIActionReactionText => {
  if (isSystemChat) {
    return UIActionReactionText.SYSTEM;
  }

  if (isGroupChat) {
    return isFamilyChat
      ? UIActionReactionText.FAMILY
      : UIActionReactionText.GROUP;
  }

  return UIActionReactionText.SINGLE;
};
